import "reflect-metadata"
import Vue from "vue"
import AmplilyWidget from "./slider-widget.vue"
import state from "../mixins/state"
import { AwOptions } from "../models/AwOptions"
import { callSetup } from "../services/setupAmplilyWidget"
import { getIdentifierKey } from "@/services/getIdentifierKey"
import { addMetaTag } from "@/services/addMetaTag"
import isPreview from "@/services/isPreview"
import addMaterialIcons from "@/services/addMaterialDesign"
import logger from "../logLevel"
import { WebinarDataService } from "@/services/WebinarDataServices"
import { container } from "tsyringe"
import {
  registerAnalyticsService,
  registerWebinarDataService
} from "@/tsyringe.config"
Vue.config.productionTip = process.env.NODE_ENV != "production"
;(window as any).setupAmplilySlider = (options: AwOptions) => {
  const el = document.getElementsByClassName("parmonic-widget")[0]
  new Vue({
    mixins: [state],
    render: h => h(AmplilyWidget),
    data() {
      return {
        momentstyle: ""
      }
    },
    created() {
      this.$data.logger = logger
      addMetaTag()
      addMaterialIcons()
      this.$data.identifierKey = getIdentifierKey()
      if (options && options.apiEndpoint)
        this.$data.baseurlAdminAppUrl = options.apiEndpoint + "/"
      if (options && options.dataEndpoint)
        this.$data.PublishedWebinarDataEndPoint = options.dataEndpoint + "/"
      this.$data.analyticsEventsCaptureEndPoint = `${this.$data.baseurlAdminAppUrl}api/v4/event/`
      this.$data.queryEndpoint =
        options && options.queryEndpoint ? options.queryEndpoint : ""
      registerAnalyticsService(
        isPreview() || process.env.NODE_ENV != "production"
      )
      registerWebinarDataService(false)
      const _dataService = container.resolve(WebinarDataService)
      _dataService.setUp(
        this.$data.PublishedWebinarDataEndPoint,
        this.$data.queryEndpoint,
        {}
      )
    }
  }).$mount(el!)
}
callSetup()
